import { render, staticRenderFns } from "./RackOld.vue?vue&type=template&id=86adf74a&scoped=true&"
import script from "./RackOld.vue?vue&type=script&lang=js&"
export * from "./RackOld.vue?vue&type=script&lang=js&"
import style0 from "./RackOld.vue?vue&type=style&index=0&id=86adf74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86adf74a",
  null
  
)

export default component.exports